/* eslint-disable react/jsx-pascal-case */
import { useFormContext } from "react-hook-form";
import TextInputLabelHookForm from "../../../../components/TextInputLabelHookForm";
import NumericInputLabel from "../../../../components/NumericInputLabel";

const OfficeFacilities = ({ disableFields }) => {
  const formMethods = useFormContext();

  return (
    <div className="m-2 bg-white box-shadow rounded-lg h-full p-1 pb-4">
      <div className="text-quinary font-bold font-sans py-2 px-4">
        Facilities
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 px-4 gap-12">
        <div className="space-y-1">
          <TextInputLabelHookForm
            name="locationCode"
            label="Location Code"
            type="text"
            register={formMethods.register("locationCode", {})}
            disabled={disableFields}
          />
        </div>
        <div className="space-y-1">
          <NumericInputLabel
            name="squareFootage"
            label="Square Footage"
            register={formMethods.register("squareFootage", {})}
            pattern="\d{8}"
            type="number"
            onKeyPress={(event: any) => {
              if (event.target.value > 99999999) {
                event.preventDefault();
              }
            }}
            disabled={disableFields}
          />
        </div>
      </div>
    </div>
  );
};

export default OfficeFacilities;
